import React from "react";
import { Target, Award, GraduationCap, Plane, Users } from "lucide-react";
import { SectionTitle, Bullet, SkillBar, SkillScale } from "./primitives";

const LeftColumn = ({ data, skillsRef, barsIn }) => (
  <aside className="space-y-8">
    {/* Profile */}
    <section>
      <SectionTitle icon={Target}>Executive Profile</SectionTitle>
      <div className="space-y-3">
        {data.profile.map((paragraph, i) => (
          <p
            key={paragraph}
            className={`text-[13.5px] leading-relaxed text-[var(--text)] ${i === 0 ? "font-semibold" : ""}`}
          >
            {paragraph}
          </p>
        ))}
      </div>
    </section>

    {/* Core capabilities */}
    <section className="pdf-break-before pdf-corecap print-break-before">
      <SectionTitle icon={Award}>Core Capabilities</SectionTitle>
      <div className="space-y-3">
        {data.capabilities.map((c) => (
          <div key={c.area}>
            <p className="text-[13px] font-semibold text-[var(--ink-dark)]">{c.area}</p>
            <p className="text-[12.5px] leading-snug text-[var(--muted)]">{c.detail}</p>
          </div>
        ))}
      </div>
    </section>

    {/* Skills */}
    <section ref={skillsRef}>
      <SectionTitle icon={Target}>Key Skills</SectionTitle>
      <SkillScale />
      {data.skills.map((s) => (
        <SkillBar key={s.name} {...s} animate={barsIn} />
      ))}
    </section>

    {/* Education */}
    <section className="print-break-before">
      <SectionTitle icon={GraduationCap}>Education & Qualifications</SectionTitle>
      <div className="space-y-3">
        {data.education.map((e) => (
          <div key={e.title}>
            <p className="text-[13.5px] font-semibold text-[var(--ink-dark)]">{e.title}</p>
            <p className="text-[12.5px] leading-snug text-[var(--muted)]">{e.meta}</p>
          </div>
        ))}
      </div>
    </section>

    {/* Aviation, Commercial & Operational */}
    <section>
      <SectionTitle icon={Plane}>Aviation, Commercial & Operational</SectionTitle>
      <ul>
        {data.aviation.map((item) => <Bullet key={item}>{item}</Bullet>)}
      </ul>
    </section>

    {/* Aviation client history */}
    <section className="pdf-break-before">
      <SectionTitle icon={Plane}>Aviation Client History</SectionTitle>
      <div className="grid grid-cols-1 gap-y-1.5">
        {data.aviationClients.map((client) => (
          <div key={client} className="relative pl-4 text-[13px] leading-snug text-[var(--text)]">
            <span className="absolute left-0 top-[7px] h-[5px] w-[5px] rounded-full bg-[var(--ink)]" />
            {client}
          </div>
        ))}
      </div>
    </section>

    {/* Additional */}
    <section>
      <SectionTitle icon={Award}>Additional Information</SectionTitle>
      <ul>
        {data.additional.map((item) => <Bullet key={item}>{item}</Bullet>)}
      </ul>
      {data.simulators && (
        <div className="mt-3">
          <div className="relative pl-4 text-[13.5px] leading-relaxed text-[var(--text)]">
            <span className="absolute left-0 top-[9px] h-[5px] w-[5px] rounded-full bg-[var(--ink)]" />
            {data.simulators.heading}
          </div>
          <ul className="mt-1.5 pl-4 space-y-1.5">
            {data.simulators.items.map((item) => (
              <li key={item} className="relative pl-4 text-[13px] leading-snug text-[var(--text)]">
                <span className="absolute left-0 top-[7px] h-[4px] w-[4px] rounded-full border border-[var(--ink)]" />
                {item}
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>

    {/* Leadership */}
    <section>
      <SectionTitle icon={Users}>Leadership, Governance & Community</SectionTitle>
      <ul>
        {data.leadership.map((item) => <Bullet key={item}>{item}</Bullet>)}
      </ul>
    </section>
  </aside>
);

export default LeftColumn;
